export const LANGUAGE_STORAGE_KEY = 'alfagpt-language-preference';
export type LangType = 'zh-CN' | 'zh-TW' | 'en' | 'ja' | 'ko';
/**
 * 保存用户语言偏好到localStorage
 */
export const saveLanguagePreference = (languageCode: string): void => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, languageCode);
    }
  } catch (error) {
    console.warn('Failed to save language preference:', error);
  }
};

/**
 * 从localStorage加载用户语言偏好
 */
export const loadLanguagePreference = (): LangType | null => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem(LANGUAGE_STORAGE_KEY) as LangType;
    }
  } catch (error) {
    console.warn('Failed to load language preference:', error);
  }
  return null;
};

/**
 * 清除语言偏好（主要用于测试和开发）
 */
export const clearLanguagePreference = (): void => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.removeItem(LANGUAGE_STORAGE_KEY);
    }
  } catch (error) {
    console.warn('Failed to clear language preference:', error);
  }
};

/**
 * 检查localStorage是否可用
 */
export const isLocalStorageAvailable = (): boolean => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const testKey = 'test-localStorage-availability';
      localStorage.setItem(testKey, 'test');
      localStorage.removeItem(testKey);
      return true;
    }
  } catch (error) {
    console.warn('localStorage is not available:', error);
  }
  return false;
};
